<template>
  <el-row style="padding:10px;width:100%" :gutter="20">
    <el-col v-for="news in newsList" :key="news.id" :span="8">
      <el-card class="news-card" :body-style="{ padding: '0px' }">
        <div @click="detailHandler(news.id)">
          <div class="img-container">
            <img style="width:100%;height: 100%;object-fit:cover" :src="nginxURL + UPLOAD_PATH['newscover'] + news.filepath" class="image">
          </div>
          <div style="padding: 14px;">
            <el-link :key="$route.fullPath" type="primary" :underline="false"> {{ news.title }} </el-link>
            <el-row type="flex" class="row-bg" justify="end">
              <div class="bottom clearfix">
                <time class="time">{{ new Date(news.publishTime).toLocaleDateString() }}</time>
              </div>
            </el-row>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { nginxURL, UPLOAD_PATH } from '@/utils/constants'

export default {
  props: ['newsList'],
  data() {
    return {
      currentDate: new Date(),
      nginxURL,
      UPLOAD_PATH
    }
  },
  methods: {
    detailHandler(id) {
      this.$router.push({
        path: '/news/detail',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style scoped>
.img-container{
    width: 100%;
    height: 220px;
}
  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }
.news-card {
  margin-top: 0px;
  transition-duration: 300ms;
  height: 310px;
  min-width: 300px;
}
.news-card:hover {
  margin-top:-10px;
    transition-duration: 300ms;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
}
  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  .clearfix:after {
      clear: both
  }
</style>
